export function initSmoothScroll() {
  const html = document.documentElement;
  let current = window.scrollY;
  let target = window.scrollY;
  let ticking = false;

  const onWheel = (event) => {
    if (event.ctrlKey) return;
    event.preventDefault();
    target += event.deltaY;
    const max = html.scrollHeight - window.innerHeight;
    target = Math.max(0, Math.min(target, max));
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(step);
    }
  };

  function step() {
    current += (target - current) * 0.14;
    if (Math.abs(target - current) < 0.4) {
      current = target;
      ticking = false;
    }
    window.scrollTo(0, current);
    if (ticking) requestAnimationFrame(step);
  }

  window.addEventListener("wheel", onWheel, { passive: false });
  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        current = window.scrollY;
        target = window.scrollY;
      }
    },
    { passive: true }
  );
}
